/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { Cart, MenuTextData, UserData, UserProfile } from "../models/types";
import { fetchMenu } from "../store/menu/action";
import { changeLanguage } from "../store/language/action";
import { getStatus, logoutUser, switchUser } from "../store/users/action";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MessageIcon from "@material-ui/icons/ChatBubble";
import {
  Box,
  Grid,
  Hidden,
  Typography,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import Login from "./Login";
import MenuLine from "./MenuLine";
import { useCookies } from "react-cookie";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import PersonIcon from "@material-ui/icons/Person";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import WhatsAppButton from "./WhatsAppButton";
import ProductSearch from "./ProductSearch";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 0.1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    buttonText: {
      fontSize: "14px",
      fontWeight: "bold",
      paddingLeft: "10px",
    },
    selectText: {
      fontSize: "14px",
      fontWeight: "bold",
      paddingTop: "3px",
      paddingLeft: "5px",
    },
    inputInput: {
      height: "35px",
      color: "inherit",
      padding: "0px",
      border: "1px solid #DA2232",
      "& .MuiInputLabel-outlined": {
        transform: "translate(14px, 12px) scale(1)",
        color: "#333333",
        fontStyle: 'italic',
      },
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    sectionMobile: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    linkButton: {
      textDecoration: "none",
      color: "#000000",
    },
    topText: {
      fontSize: "14px",
      color: "#333333",
      verticalAlign: "middle",
      display: "inline-flex",
    },
    hl: {
      height: "70px",
    },
    clientService: {
      fontSize: "12px",
    },
    clientServicePhone: {
      fontSize: "12px",
      fontWeight: "bold",
    },
    clientBox: {
      borderRight: "1px solid #f2f2f2",
      textAlign: "right",
      paddingRight: "5px",
    },
    cart: {
      backgroundColor: "#DA2232",
      color: "#ffffff",
    },
    languageBox: {
      boxShadow:
        "rgba(0, 0, 0, 0.23) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
      cursor: "pointer",
    },
    user: {
      color: "#000000",
      fontSize: "35px",
      "&:hover": {
        cursor: "pointer",
        color: "#da2232",
      },
    },
    shoppingCart: {
      color: "#000000",
      fontSize: "35px",
      "&:hover": {
        cursor: "pointer",
        color: "#da2232",
      },
    },
    red: {
      color: "#EC574E",
      fontSize: "30px",
      "&:hover": {
        cursor: "pointer",
        color: "#da2232",
      },
    },
    headerActions: {
      display: "inline-flex",
      alignItems: "center",
      flexShrink: 0,
    },
    mobileActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      flexWrap: "nowrap",
      minWidth: "104px",
      overflow: "visible",
      position: "relative",
      zIndex: 2,
    },
    menuActions: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
    },
    mobileLogo: {
      overflow: "hidden",
      textAlign: "center",
    },
    mobileLogoImage: {
      height: "40px",
      maxWidth: "100%",
    },
  })
);

interface PropsFromState {
  language: string;
  login: boolean;
  loading: boolean;
  user: UserData;
  profile: UserProfile;
  cart?: Cart;
  text: MenuTextData;
}

interface propsFromDispatch {
  changeLanguage: (language: string) => any;
  fetchMenu: () => any;
  getStatus: (cookie: any, setCookie: any) => any;
  logoutUser: (setCookie: any) => any;
  switchUser: (setCookie: any, companyId: string) => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const HeaderLine: React.FC<AllProps> = ({
  language,
  login,
  loading,
  user,
  profile,
  cart,
  text,
  changeLanguage,
  fetchMenu,
  getStatus,
  logoutUser,
  switchUser,
}) => {
  useEffect(() => {
    getStatus(cookies, setCookie);
    fetchMenu();
  }, []);

  const classes = useStyles();
  let history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorSwitcher, setSwitcherEl] = React.useState<null | HTMLElement>(
    null
  );
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const [isLoginOpen, handleLogin] = useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isSwitcherOpen = Boolean(anchorSwitcher);
  const [cookies, setCookie] = useCookies();
  const intl = useIntl();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSwitcherOpen = (event: React.MouseEvent<HTMLElement>) => {
    setSwitcherEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSwitcherClose = () => {
    setSwitcherEl(null);
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const popupHandler = () => {
    handleLogin((current) => !current);
  };

  const handleLanguage = (language: string) => {
    changeLanguage(language);
    handleMenuClose();
  };

  const handleSwitchUser = (companyId: string) => {
    switchUser(setCookie, companyId);
    setSwitcherEl(null);
    history.push("/profile");
  };

  const handleLogoutUser = () => {
    logoutUser(setCookie);
    handleLogin(false);
    history.push("/");
  };

  const menuId = "language-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem
        className={classes.selectText}
        value={"lv"}
        onClick={(e) => handleLanguage("lv")}
      >
        <FormattedMessage id="language.lv" />
      </MenuItem>
      <MenuItem
        className={classes.selectText}
        value={"en"}
        onClick={(e) => handleLanguage("en")}
      >
        <FormattedMessage id="language.en" />
      </MenuItem>
    </Menu>
  );

  const switcherId = "switcher-menu";
  const renderSwitcher =
    user.profile?.organization && user.profile?.organization.length > 1 ? (
      <Menu
        anchorEl={anchorSwitcher}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        id={switcherId}
        keepMounted
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={isSwitcherOpen}
        onClose={handleSwitcherClose}
      >
        {user.profile.organization.map((organizationDetails) => (
          <MenuItem
            className={classes.selectText}
            value={organizationDetails.number}
            onClick={(e) => handleSwitchUser(organizationDetails.number)}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item md={2}>
                {organizationDetails.type === "BUSINESS" ? (
                  <WorkOutlineIcon />
                ) : (
                  <PersonIcon />
                )}
                </Grid>
                <Grid item md={8}>
                  {organizationDetails.name}
                </Grid>
            </Grid>
          </MenuItem>
        ))}
      </Menu>
    ) : null;

  const mobileMenuId = "mobile-menu";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        {login && !loading ? (
          <Link to="/profile" className={classes.linkButton}>
            <IconButton
              edge="end"
              aria-label={intl.formatMessage({ id: "aria.userAccount" })}
              aria-controls={menuId}
              aria-haspopup="true"
              color="inherit"
            >
              <AccountCircle />
              <div className={classes.buttonText}>{user?.profile?.name}</div>
            </IconButton>
          </Link>
        ) : null}
        {!login ? (
          <IconButton
            edge="end"
            aria-label={intl.formatMessage({ id: "aria.userAccount" })}
            aria-haspopup="true"
            onClick={popupHandler}
            color="inherit"
          >
            <AccountCircle />
            <div className={classes.buttonText}>
              <FormattedMessage id="login" />
            </div>
          </IconButton>
        ) : null}
      </MenuItem>
      <MenuItem>
          <WhatsAppButton />
      </MenuItem>
      <MenuItem>
        <div className={classes.menuActions}>
          <Link to="cart" className={classes.linkButton}>
            <IconButton aria-label={intl.formatMessage({ id: "cart" })} color="inherit">
              <Badge color="secondary">
                <NotificationsIcon />
              </Badge>
              <div className={classes.buttonText}>
                <FormattedMessage id="cart" />
              </div>
            </IconButton>
          </Link>
        </div>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <AppBar color="primary" position="sticky">
        <Login isLoginOpen={isLoginOpen} closeHandler={popupHandler} />
        <Hidden xsDown>
          <Grid container spacing={0} direction="row" justify="center">
            <Grid item xs={false} md={1}></Grid>
            <Grid item xs={false} md={3}>
              <Box textAlign="center">
                <Typography className={classes.topText}>
                  <img
                    src="/images/diennakts-klientu-serviss.svg"
                    alt=""
                    height="22px"
                  />
                  <FormattedMessage id="header.service" />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={false} md={3}>
              <Box textAlign="center">
                <Typography className={classes.topText}>
                  <img
                    src="/images/pieredze-buvnieciba.svg"
                    alt=""
                    height="22px"
                  />
                  <FormattedMessage id="header.experience" />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={false} md={3}>
              <Box textAlign="center">
                <Typography className={classes.topText}>
                  <img
                    src="/images/vienmer-izdevigas-cenas.svg"
                    alt=""
                    height="22px"
                  />
                  <FormattedMessage id="header.prices" />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={false} md={1}></Grid>
          </Grid>
        </Hidden>
        <Toolbar className={classes.hl}>
          <Hidden xsDown>
            <Link to="/">
              <Box>
                <img
                  src="/images/stats-rent-logo.svg"
                  height="40px"
                  alt="Stats Rent"
                />
              </Box>
            </Link>
            <ProductSearch />
          </Hidden>
          <Hidden smUp>
            <Grid container spacing={0} direction="row">
              <Grid item xs={2}>
                {!login ? (
                  <IconButton
                    edge="end"
                    aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                    aria-haspopup="true"
                    onClick={popupHandler}
                    className={classes.user}
                  >
                    <PersonIcon style={{ fontSize: "35px" }} />
                  </IconButton>
                ) : null}
                {login && !loading ? (
                  <IconButton
                    edge="end"
                    aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                    aria-haspopup="true"
                    color="inherit"
                    onClick={handleLogoutUser}
                  >
                    <LogoutIcon className={classes.red} />
                  </IconButton>
                ) : null}
              </Grid>
              <Grid item xs={7} className={classes.mobileLogo}>
                <Link to="/">
                  <img
                    src="/images/stats-rent-logo.svg"
                    alt="Stats Rent"
                    className={classes.mobileLogoImage}
                  />
                </Link>
              </Grid>
              <Grid item xs={1}>
                <WhatsAppButton />
              </Grid>
              <Grid item xs={1}>
                <Link to="/cart" className={classes.linkButton}>
                  <IconButton aria-label={intl.formatMessage({ id: "aria.shoppingCart" })} color="inherit">
                    <Badge
                      badgeContent={cart?.count}
                      classes={{ badge: classes.cart }}
                    >
                      <ShoppingCartIcon className={classes.shoppingCart} />
                    </Badge>
                  </IconButton>
                </Link>
              </Grid>
            </Grid>
          </Hidden>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            {!login ? (
              <IconButton
                edge="end"
                aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                aria-haspopup="true"
                onClick={popupHandler}
                className={classes.user}
              >
                <PersonIcon style={{ fontSize: "35px" }} />
              </IconButton>
            ) : null}
            {login && !loading ? (
              <>
                <Link to="/profile" className={classes.linkButton}>
                  <IconButton
                    edge="end"
                    aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                    aria-controls={menuId}
                    aria-haspopup="true"
                    className={classes.user}
                  >
                    <PersonIcon style={{ fontSize: "35px" }} />
                    <div className={classes.buttonText}>
                      {user.profile.name}
                    </div>
                  </IconButton>
                </Link>
                {user.profile?.organization &&
                user.profile?.organization.length > 1 ? (
                  <IconButton
                    edge="end"
                    aria-label={intl.formatMessage({ id: "aria.userOrganization" })}
                    aria-controls={switcherId}
                    aria-haspopup="true"
                    color="inherit"
                    onClick={handleSwitcherOpen}
                    className={classes.user}
                  >
                    <WorkOutlineIcon />
                    <div className={classes.buttonText}>
                      {user.profile.title} ({user.profile.organization.length})
                    </div>
                  </IconButton>
                ) : null}
              </>
            ) : null}
            {login && !loading ? (
              <IconButton
                edge="end"
                aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                aria-haspopup="true"
                color="inherit"
                onClick={handleLogoutUser}
              >
                <LogoutIcon className={classes.red} />
              </IconButton>
            ) : null}
            {profile?.inboxNew ? (
              <Link to="/profile/sazina" className={classes.linkButton}>
                <IconButton aria-label={intl.formatMessage({ id: "aria.message" })} color="inherit">
                  <Badge
                    badgeContent={profile?.inboxNewCount}
                    classes={{ badge: classes.cart }}
                  >
                    <MessageIcon className={classes.shoppingCart} />
                  </Badge>
                </IconButton>
              </Link>
            ) : null}
            <div className={classes.headerActions}>
              <WhatsAppButton />
              <Link to="/cart" className={classes.linkButton}>
                <IconButton aria-label={intl.formatMessage({ id: "aria.shoppingCart" })} color="inherit">
                  <Badge
                    badgeContent={cart?.count}
                    classes={{ badge: classes.cart }}
                  >
                    <ShoppingCartIcon className={classes.shoppingCart} />
                  </Badge>
                </IconButton>
              </Link>
            </div>
            <Box pt={1} className={classes.clientBox}>
              <Typography className={classes.clientService}>
                <FormattedMessage id="header.clientService" />
              </Typography>
              <Typography className={classes.clientServicePhone}>
                <FormattedMessage id="header.clientServicePhone" />
              </Typography>
            </Box>
            <Box pl={2} pt={2} pr={2} onClick={handleMenuOpen}>
              <img
                src={"/images/languages/" + language + ".svg"}
                alt=""
                height="20px"
                className={classes.languageBox}
              />
            </Box>
          </div>
        </Toolbar>
        <MenuLine />
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {renderSwitcher}
    </>
  );
};

const mapStateToProps = ({ language, user, menu }: ApplicationState) => ({
  language: language.language,
  login: user.login,
  loading: user.loading,
  user: user.user,
  profile: user.profile,
  cart: user.cart,
  text: menu.text,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchMenu: () => {
      dispatch(fetchMenu());
    },
    changeLanguage: (language: string) => {
      dispatch(changeLanguage(language));
    },
    getStatus: (cookie: any, setCookie: any) => {
      dispatch(getStatus(cookie, setCookie));
    },
    logoutUser: (setCookie: any) => {
      dispatch(logoutUser(setCookie));
    },
    switchUser: (setCookie: any, companyId: string) => {
      dispatch(switchUser(setCookie, companyId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLine);
